export type OfferKind =
  | 'nav'
  | 'build'
  | 'page'
  | 'report'
  // 'custom' (post-chart "open as custom page") is no longer offered anywhere;
  // it stays parseable so a stray marker degrades to plain text, never raw
  // `[phrase](offer:custom)` markup.
  | 'custom'
  | 'filters';

/** Matches `[visible phrase](offer:nav)` / `[…](offer:build)` / `[…](offer:page)` / `[…](offer:report)` / `[…](offer:custom)` / `[…](offer:filters)` only. */
export const OFFER_MARKER_REGEX =
  /\[([^\]]+)\]\(offer:(nav|build|page|report|custom|filters)\)/g;

/** True when `text` contains at least one offer trigger of `kind`. */
export function hasOfferMarker(text: string, kind: OfferKind): boolean {
  // Fresh regex each call — the global flag carries lastIndex state.
  const re = new RegExp(OFFER_MARKER_REGEX.source, 'g');
  for (const m of text.matchAll(re)) {
    if (m[2] === kind) {
      return true;
    }
  }
  return false;
}
